export default {
	questions_about_the_program_find_yout_answers_here: "Questions about the program? Find your answers here."
}
